import React, { useState, useContext, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { BiPlus, BiUpload, BiX } from "react-icons/bi";
import { iconStyle } from "../../../utils/generalUtils";
import { SocketContext } from "../../../app/socket";
import "./create-user.scss";
import { useSelector } from "react-redux";
import Compress from "compress.js";
import ExamThumbnail from "../../../components/ExamThumbnail/exam-thumbnail";

function CreateUser({
  professors,
  students,
  parents,
  isExpanded,
  setIsExpanded,
  isOnlyParent,
  studentId,
}) {
  const index = 0;
  const [submitFiles, setSubmitFiles] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);
  const compress = new Compress();
  const [answerText, setAnswerText] = useState("");
  const envVars = useSelector((state) => state.profile.environmentVars);
  const socketContext = useContext(SocketContext);
  const [style, setStyle] = useState({});
  const containerRef = useRef(null);
  const [photoFile, setPhotoFile] = useState();
  const [photoName, setPhotoName] = useState();
  const [errorMsg, setErrorMsg] = useState("");

  const [emailExists, setEmailExists] = useState(false);
  const [createdUser, setCreatedUser] = useState(false);

  const hasCameraAccess = useSelector((state) => state.profile.hasCameraAccess);

  const openCard = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const cleanUpCreatedUserListener = createdUserListener();
    const cleanUpGetAllUsers = getAllUsers();
    return () => {
      cleanUpCreatedUserListener();
      cleanUpGetAllUsers();
    };
  }, []);

  useEffect(() => {
    if (isExpanded) {
      setEmailExists(false);
      const rect = containerRef.current.getBoundingClientRect();
      const topPosition = rect.top;
      const leftPosition = rect.left;
      let newPositionStyle = {
        top: window.innerHeight * 0.1 - topPosition + "px",
        left: window.innerWidth * 0.25 - leftPosition + "px",
        width: "50vw",
        height: "80vh",
      };
      if (window.innerWidth < 800) {
        newPositionStyle = {
          top: window.innerHeight * 0.1 - topPosition + "px",
          left: window.innerWidth * 0.05 - leftPosition + "px",
          width: "90vw",
          height: "80vh",
        };
      }

      setStyle(newPositionStyle);
    } else {
      setStyle({});
      setErrorMsg("");
      setFirstName("");
      setLastName("");
      setPwd("");
      setRepeatPwd("");
      setEmail("");
    }
    if (window.innerWidth < 700) {
      if (isExpanded) {
        document.getElementById("main-app").style.overflowY = "hidden";
      } else {
        document.getElementById("main-app").style.overflowY = "auto";
      }
    } else {
      if (isExpanded) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "auto";
      }
    }
  }, [isExpanded]);

  const createdUserListener = () => {
    const actualListener = (data) => {
      if (data) {
        setCreatedUser(true);
      } else {
        setErrorMsg("mail");
      }
    };
    socketContext.socket.on("createdUser", actualListener);

    return () => {
      socketContext.socket.off("createdUser", actualListener);
    };
  };

  useEffect(() => {
    setIsExpanded(false);
  }, [createdUser]);

  const [allUsers, setAllUsers] = useState([]);

  const getAllUsers = () => {
    const uniqueId = "get-all-users";
    let args = {};

    const getProfessorsListener = (data) => {
      setAllUsers(data);
    };

    const refreshProfessorsListener = () => {
      socketContext.socket.emit("getAllUsersWithParams", args);
    };

    socketContext.socket.on(
      "allUsersWithParams" + uniqueId,
      getProfessorsListener
    );
    socketContext.socket.emit("getAllUsersWithParams", args);
    socketContext.socket.on(
      "refreshAllUsersWithParams",
      refreshProfessorsListener
    );

    return () => {
      socketContext.socket.off("getAllUsersWithParams", getProfessorsListener);
      socketContext.socket.off(
        "allUsersWithParams" + uniqueId,
        getProfessorsListener
      );
      socketContext.socket.off(
        "refreshAllUsersWithParams",
        refreshProfessorsListener
      );
    };
  };

  const imageChange = async (event) => {
    let fileList = Array.from(event.target.files);

    const imageList = fileList.filter(
      (file) => file.type !== "application/pdf"
    );
    const pdfList = fileList.filter((file) => file.type === "application/pdf");

    let tempThumbnailList = [];

    let updatedFileList = submitFiles;
    updatedFileList[index] = [];

    await compress
      .compress(imageList, {
        size: 2, // the max size in MB, defaults to 2MB
        quality: 0.75, // the quality of the image, max is 1,
        maxWidth: 1920, // the max width of the output image, defaults to 1920px
        maxHeight: 1920, // the max height of the output image, defaults to 1920px
        resize: true, // defaults to true, set false if you do not want to resize the image width and height
        rotate: false, // See the rotation section below
      })
      .then((data) => {
        data.forEach(function (singleData) {
          const base64 = singleData.data;
          const name = singleData.alt;
          const imgExt = singleData.ext;

          const blob = Compress.convertBase64ToFile(base64, imgExt);

          // let mFile = dataURLToFile(base64, name);
          let file = new File([blob], name);
          updatedFileList[index].push(file);

          let baseData = "data:" + imgExt + ";base64," + base64;
          tempThumbnailList.push(baseData);
        });
      });
    // set thumbnails (base64 inside)
    setThumbnails(tempThumbnailList);

    updatedFileList.push(pdfList);
    // set files (file types inside)
    setSubmitFiles(updatedFileList);
  };

  const populateThumbnails = () => {
    return thumbnails.map((image, i) => {
      return (
        <ExamThumbnail
          key={i}
          index={i}
          removeThumbnail={removeThumbnail}
          image={image}
        />
      );
    });
  };

  const removeThumbnail = (i) => {
    let updatedFileList = submitFiles;
    let tempThumbnails = thumbnails;

    if (thumbnails.length >= 1) {
      updatedFileList[index].splice(i, 1);
      tempThumbnails.splice(i, 1);
    } else {
      updatedFileList[index] = [];
      tempThumbnails = [];
    }

    setThumbnails(Array.from(tempThumbnails));
    setSubmitFiles(updatedFileList);
  };

  const [userType, setUserType] = useState("student");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [repeatPwd, setRepeatPwd] = useState("");

  const saveUser = () => {
    const isValid = (pwd) => /[A-Za-zΑ-Ωα-ω]/.test(pwd) && /\d/.test(pwd);
    if (!lastName) {
      setErrorMsg("last-name");
    } else if (!firstName) {
      setErrorMsg("first-name");
    } else if (allUsers.find((usr) => usr.email == email)) {
      setErrorMsg("email");
    } else if (!(/[A-Za-zΑ-Ωα-ω]/.test(pwd) && /\d/.test(pwd))) {
      setErrorMsg("weak-pwd");
    } else if (pwd.length < 6) {
      setErrorMsg("short-pwd");
    } else if (pwd != repeatPwd) {
      setErrorMsg("repeat-pwd");
    } else {
      let body = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        user_type: isOnlyParent ? "parent" : userType,
        pwd: pwd,
        student_id: studentId,
        from_secretary: true,
      };
      socketContext.socket.emit("createUser", body);
    }
  };

  return (
    <div
      ref={containerRef}
      className={"create-user " + (isExpanded ? "is-expanded" : "is-collapsed")}
    >
      {isExpanded && (
        <div
          onClick={() => setIsExpanded(false)}
          className={"modal-background show"}
        ></div>
      )}
      <motion.div
        initial={false}
        className={
          "create-user__content " +
          (isExpanded ? "is-expanded" : "is-collapsed")
        }
        onClick={openCard}
        style={style}
      >
        {isExpanded ? (
          <div
            className="create-user__config no-scrollbar"
            onClick={(e) => e.stopPropagation()}
          >
            {!isOnlyParent ? (
              <div className="user-item">
                <div className="user-item__type">
                  <div
                    className={
                      "type-item " + (userType == "admin" ? " active" : "")
                    }
                    onClick={() => setUserType("admin")}
                  >
                    Ιδιοκτήτης
                  </div>
                  <div
                    className={
                      "type-item " + (userType == "professor" ? " active" : "")
                    }
                    onClick={() => setUserType("professor")}
                  >
                    Γυμναστής
                  </div>
                  <div
                    className={
                      "type-item " + (userType == "student" ? " active" : "")
                    }
                    onClick={() => setUserType("student")}
                  >
                    Αθλητής
                  </div>
                </div>
              </div>
            ) : (
              <span className="user-item__title">Προσθήκη Γονέα</span>
            )}
            <div className="user-item">
              <span className="user-item__label">Επώνυμο</span>
              {errorMsg == "last-name" ? (
                <span className="user-item__error">
                  Παρακαλώ εισάγετε επώνυμο...
                </span>
              ) : (
                ""
              )}
              <input
                placeholder="Εισάγετε επώνυμο"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="input"
              />
            </div>
            <div className="user-item">
              <span className="user-item__label">Όνομα</span>
              {errorMsg == "first-name" ? (
                <span className="user-item__error">
                  Παρακαλώ εισάγετε όνομα...
                </span>
              ) : (
                ""
              )}
              <input
                placeholder="Εισάγετε όνομα"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="input"
              />
            </div>
            <div className="user-item">
              <span className="user-item__label">Email / Username</span>
              {errorMsg == "mail" ? (
                <span className="user-item__error">
                  Το email υπάρχει ήδη σε κάποιον άλλον χρήστη...
                </span>
              ) : (
                ""
              )}
              <input
                placeholder="Εισάγετε email / Username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </div>
            <div className="user-item">
              <span className="user-item__label">Κωδικός</span>
              {errorMsg == "weak-pwd" ? (
                <span className="user-item__error">
                  Ο κωδικός πρέπει να περιέχει τουλάχιστον έναν αριθμό και ένα
                  γράμμα
                </span>
              ) : (
                ""
              )}
              {errorMsg == "short-pwd" ? (
                <span className="user-item__error">
                  Ο κωδικός πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες.
                </span>
              ) : (
                ""
              )}
              <input
                type="password"
                placeholder="Εισάγετε κωδικό"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                className="input"
              />
            </div>
            <div className="user-item">
              <span className="user-item__label">Επαναλάβετε τον κωδικό</span>
              {errorMsg == "repeat-pwd" ? (
                <span className="user-item__error">
                  Οι 2 κωδικοί δεν είναι ίδιοι...
                </span>
              ) : (
                ""
              )}
              <input
                type="password"
                placeholder="Επανάληψη κωδικού"
                value={repeatPwd}
                onChange={(e) => setRepeatPwd(e.target.value)}
                className="input"
              />
            </div>
            <div className="user-item-upload">
              <div className="upload-text">
                <span className="label">Γενικές Σημειώσεις</span>
                <textarea
                  value={answerText}
                  onChange={(e) => setAnswerText(e.target.value)}
                  placeholder="Εισάγετε τις σημείωσεις σας εδώ..."
                ></textarea>
              </div>
              <div className="upload-files">
                <span className="label">Αρχεία</span>
                <div className="upload-files__button">
                  <BiUpload
                    size={"60px"}
                    color={"#ccc"}
                    style={iconStyle("transparent")}
                  />
                  {hasCameraAccess !== 0 && (
                    <input
                      className="upload-files__button-input"
                      type="file"
                      accept=".pdf, .jpeg, .jpg, .png"
                      name="myImage"
                      onChange={imageChange}
                      multiple
                    />
                  )}
                </div>
                {!hasCameraAccess && (
                  <span className="upload-files__error">
                    Ενεργοποιήστε τα δικαιώματα κάμερας για να έχετε πρόσβαση
                    στην κάμερα και στα αρχεία σας
                  </span>
                )}
                <div className="upload-files__thumbnails">
                  {populateThumbnails()}
                </div>
              </div>
            </div>
            <div className="create-user__config-actions">
              <button className="cta" onClick={() => saveUser()}>
                Δημιουργία
              </button>
            </div>
            <div
              className="create-user__config-close"
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(false);
              }}
            >
              <BiX
                size={"30px"}
                color={"#cccccc"}
                style={iconStyle("#727272")}
              />
            </div>
          </div>
        ) : (
          <div className="create-user__preview">
            <BiPlus
              size={"30px"}
              color={"#cccccc"}
              style={iconStyle("transparent")}
            />
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default CreateUser;
